import { createAsyncThunk } from "@reduxjs/toolkit";
import i18next from "i18next";
import { toast } from "react-toastify";
import { apiCall } from "services/api";

import { toFormData } from "utils/files";

import {
  ForgotValues,
  LoginValues,
  ResetPasswordValues,
  UserFormData,
} from "./types";

export const addUser = createAsyncThunk(
  "/auth/register",
  async (props: UserFormData, { rejectWithValue }) => {
    try {
      const formdata = toFormData(props);

      const response = await apiCall().post("/auth/register", formdata);

      return response.data;
    } catch (error: any) {
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

export const get2fa = createAsyncThunk(
  "/auth/get2fa",
  async (_, { rejectWithValue }) => {
    try {
      const response = await apiCall().get(`auth/get2fa`);

      return response.data;
    } catch (error: any) {
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

export const login2fa = createAsyncThunk(
  "/auth/login2fa",
  async (
    { token, token2fa }: { token: string; token2fa: string },
    { rejectWithValue }
  ) => {
    try {
      const response = await apiCall({
        Authorization: `Bearer ${token}`,
      }).post(`auth/login2fa`, {
        token_2fa: token2fa,
      });

      return response.data;
    } catch (error: any) {
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

export const login = createAsyncThunk(
  "/auth/login",
  async ({ email, password }: LoginValues, { rejectWithValue }) => {
    try {
      const response = await apiCall().post("/auth/login", {
        email: email,
        password: password,
      });

      if (response.data.two_factor_required) {
        return { data: null, token: response.data.token, twoStepAuth: true };
      }

      return response.data;
      // return { data: null, token: null, twoStepAuth: true };
    } catch (error: any) {
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

export const forgot = createAsyncThunk(
  "/auth/forgot-password",
  async ({ email, return_url }: ForgotValues, { rejectWithValue }) => {
    try {
      const response = await apiCall().post("/auth/forgot-password", {
        email,
        return_url,
      });

      toast.success(
        i18next.getResource(i18next.language, "translation", "resetlinksuccess")
      );
      return response.data;
    } catch (error: any) {
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

export const resetPassword = createAsyncThunk(
  "/auth/reset-password",
  async (
    { token, email, password, password_confirmation }: ResetPasswordValues,
    { rejectWithValue }
  ) => {
    try {
      const response = await apiCall().post("/auth/reset-password", {
        token,
        email,
        password,
        password_confirmation,
      });

      return response.data;
    } catch (error: any) {
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

export const updateOwnProfile = createAsyncThunk(
  "/auth/profile",
  async ({ values }: { values: UserFormData }, { rejectWithValue }) => {
    try {
      // const formdata = toFormData(values);
      //   console.log(values, "user update");
      const response = await apiCall().post(
        "/auth/profile?_method=PATCH",
        values
      );

      return response.data;
    } catch (error: any) {
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

export const getOwnProfile = createAsyncThunk(
  "/auth/getOwnProfile/:id",
  async (id: number, { rejectWithValue }) => {
    try {
      const response = await apiCall().get(`/auth/users/${id}`);

      return response.data;
    } catch (error: any) {
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

export const deleteUserProfileAvatar = createAsyncThunk(
  "/auth/profile/avatar/delete",
  async (values, { rejectWithValue }) => {
    try {
      const response = await apiCall().delete("/auth/profile/avatar");
      toast.success(
        i18next.getResource(
          i18next.language,
          "translation",
          "userEditForm.avatarDeleted"
        )
      );
      return response.data;
    } catch (error: any) {
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);

export const nafathLogin = createAsyncThunk(
  "/auth/nafath-login",
  async ({ national_id }: { national_id: string }, { rejectWithValue }) => {
    try {
      const response = await apiCall().post("/auth/nafath-login", {
        national_id,
      });

      return response.data;
    } catch (error: any) {
      toast.error(error.response.data.message);
      return rejectWithValue(error.response.data);
    }
  }
);
